import Body from "../../Components/Server/AddBranches";
import Header from "../../Components/Server/Header";
import LeftSideBare from "../../Components/Server/LeftSideBare";

const FilterBranchesPage=()=>{

    return <>
    <>
  <meta charSet="utf-8" />
  <meta content="width=device-width, initial-scale=1.0" name="viewport" />
  <style
    dangerouslySetInnerHTML={{
      __html:
        "@layer base{html,body{margin:0;padding:0;}body{overscroll-behavior:none;}main>:first-child{margin-top:0!important;}main>:last-child{margin-bottom:0!important;}}::-webkit-scrollbar{display:none;}"
    }}
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    rel="stylesheet"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap"
    rel="stylesheet"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@100..900&display=swap"
    rel="stylesheet"
  />
  <LeftSideBare />
  <div className="pr-[280px]">
    <Header />
    <Body />
  </div>
</>

    </>
}
export default FilterBranchesPage;